import { MutationDeleteAddressArgs } from '../../types/generated';
import { apiMutate } from '../../utils/mutation';
import ServiceConfigs from '../../config';
import deleteAddressMutation from '../../mutations/address/deleteAddress';
import useAddressBook from './useAddressBook';
import { useFulfillmentSettings } from '../../../contexts';

type UseDeleteAddressType = () => (variables: MutationDeleteAddressArgs) => Promise<boolean>;

const useDeleteAddress: UseDeleteAddressType = () => {
  const { area } = useFulfillmentSettings();
  const { data: addressBook, mutate: mutateAddressBook } = useAddressBook({ areaId: area?.id });

  return variables =>
    apiMutate({
      mutation: deleteAddressMutation,
      variables: { ...variables },
      requestHeaders: { ...ServiceConfigs.getAuthorizationHeader() },
      handler: (res: any) => res?.deleteAddress,
    }).then((isAddressDeleted: boolean) => {
      const updatedAddresses = addressBook?.addresses?.filter(
        address => isAddressDeleted && address.id !== variables.addressId,
      );
      mutateAddressBook({ ...addressBook, addresses: [...updatedAddresses] }, false);
      return isAddressDeleted;
    });
};

export default useDeleteAddress;
